import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useMemo, useState } from 'react';
import { ResourceCalendar } from '../../types';

interface ResourceCalendarsAutoCompleteProps {
  setAutoCompleteValue: (value: string) => void;
  size: 'small' | 'medium';
  disabled?: boolean;
  hasError?: boolean;
  newKey?: string;
  resourceCalendars: ResourceCalendar[];
  helperText?: string;
  /** Shows this placeholder instead of the floating label. */
  placeholder?: string;
}

export default function ResourceCalendarsAutoComplete({
  setAutoCompleteValue,
  size,
  disabled,
  hasError,
  resourceCalendars,
  helperText,
  newKey,
  placeholder,
}: ResourceCalendarsAutoCompleteProps) {
  const [inputValue, setInputValue] = useState('');

  const key = useMemo(
    () => newKey || new Date().getTime().toString(),
    [newKey]
  );

  return (
    <Autocomplete
      key={key}
      id="resource-calendars-autocomplete"
      disabled={disabled}
      componentsProps={{
        paper: {
          sx: {
            minWidth: 400,
          },
        },
      }}
      getOptionLabel={(option) => option.resourceName}
      options={[...resourceCalendars].sort((a, b) => {
        if (a.resourceName < b.resourceName) return -1;
        if (a.resourceName > b.resourceName) return 1;
        return 0;
      })}
      size={size}
      autoComplete
      autoHighlight
      onChange={(_event, newValue) => {
        setAutoCompleteValue(
          newValue?.resourceEmail || newValue?.resourceId || ''
        );
      }}
      noOptionsText="No Resource Calendars Found"
      renderInput={(params) => (
        <TextField
          {...params}
          label={placeholder ? undefined : 'Search for a resource calendar'}
          placeholder={placeholder}
          fullWidth
          error={hasError}
          helperText={helperText}
        />
      )}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue) => {
        setInputValue(newInputValue);
      }}
    />
  );
}
